
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import { nextTick, onMounted, ref, watch, defineComponent, PropType } from 'vue'
import SpecialFeatureCard from '@/components/block/SpecialFeatureCard.vue'
import Triangle from '@/components/elements/svg/Triangle.vue'
import { TopSpecialFeaturesItem } from '@/types/TopSpecialFeatures'

export default defineComponent({
  name: 'SpecialFeatureCardSlider',

  props: {
    items: {
      type: Array as PropType<TopSpecialFeaturesItem[]>,
      default: () => []
    }
  },

  components: {
    SpecialFeatureCard,
    Triangle
  },

  setup(props) {
    const mySwiper = ref<Swiper | null>(null)

    watch(
      () => props.items,
      () => {
        nextTick(() => {
          // 1画面で複数使うと配列になるっぽい
          if (Array.isArray(mySwiper.value)) {
            mySwiper.value.forEach((sw: Swiper) => sw.update())
          } else {
            mySwiper.value?.update()
          }
        })
      }
    )

    onMounted(() => {
      Swiper.use([Navigation, Pagination])
      mySwiper.value = new Swiper('.specialFeatureSwiper', {
        breakpoints: {
          600: {
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          800: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          900: {
            slidesPerView: 5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16
          },
          1000: {
            slidesPerView: 5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 40
          }
        },
        slidesPerView: 2,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        spaceBetween: 16,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.specialFeatureSwiperNext',
          prevEl: '.specialFeatureSwiperPrev'
        }
      })
    })
  }
})
